import { render, staticRenderFns } from "./mediaCenter.vue?vue&type=template&id=5335db92&scoped=true&lang=html&"
import script from "./mediaCenter.vue?vue&type=script&lang=js&"
export * from "./mediaCenter.vue?vue&type=script&lang=js&"
import style0 from "./mediaCenter.vue?vue&type=style&index=0&id=5335db92&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5335db92",
  null
  
)

component.options.__file = "mediaCenter.vue"
export default component.exports